import { Descriptions, Row } from "antd";
import getAtribute from "../../../utils/getAtribute";

export function DetailsSystem({ entidade }) {
  return (
    <>
      <Row justify="center" align="middle">
        <div className="ant-descriptions-title">Sistema</div>
      </Row>
      <Descriptions>
        <Descriptions.Item label="Nome">
          {getAtribute(entidade, "sistema").replace("_", " ")}
        </Descriptions.Item>
        <Descriptions.Item label="Nível de acesso">
          {getAtribute(entidade, "nivel")}
        </Descriptions.Item>
        <Descriptions.Item label="Justificativa">
          {getAtribute(entidade, "justificativa")}
        </Descriptions.Item>
      </Descriptions>

      {getAtribute(entidade, "sistema") === "AGILIS" && (
        <Descriptions>
          <Descriptions.Item label="Mac da Máquina">
            {getAtribute(entidade, "macMaquina")}
          </Descriptions.Item>
          <Descriptions.Item label="Nome da Máquina">
            {getAtribute(entidade, "nomeMaquina")}
          </Descriptions.Item>
          <Descriptions.Item label="Número HD">
            {getAtribute(entidade, "numSerieHd")}
          </Descriptions.Item>
          <Descriptions.Item label="IP da Máquina">
            {getAtribute(entidade, "ipMaquina")}
          </Descriptions.Item>
          <Descriptions.Item label="Tombo da Máquina">
            {getAtribute(entidade, "tomboMaquina")}
          </Descriptions.Item>
        </Descriptions>
      )}
      {getAtribute(entidade, "sistema") === "ROTAS" && (
        <Descriptions>
          <Descriptions.Item label="AIS/Grupo">
            {getAtribute(entidade, "ais_grupo")}
          </Descriptions.Item>
        </Descriptions>
      )}

      <div className="divider" />
    </>
  );
}
